import { createRuntimeOperationType, isRuntimeOperationConfig } from './common';
export const joinListAsTextOperationType = createRuntimeOperationType({
    kind: 'JOIN_LIST_AS_TEXT',
    dependencies: () => [],
    run: (value, context, operations) => {
        if (!value || typeof value !== 'object') {
            throw new Error(`JOIN_LIST_AS_TEXT value must be an object with 'items' property. Got ${JSON.stringify(value)}`);
        }
        const { items, delimiter = ' | ' } = value;
        if (!items || !Array.isArray(items)) {
            return '';
        }
        if (items.some(item => isRuntimeOperationConfig(item))) {
            return '';
        }
        const textValues = items
            .map((item) => {
            if (item && typeof item === 'object' && 'kind' in item) {
                const contentNode = item;
                if (contentNode.state?.asText) {
                    return String(contentNode.state.asText);
                }
                if (contentNode.kind === 'SCALAR' && contentNode.data != null) {
                    return String(contentNode.data);
                }
                if (contentNode.state?.asValue != null) {
                    return String(contentNode.state.asValue);
                }
                if (contentNode.data != null) {
                    return String(contentNode.data);
                }
                return null;
            }
            if (item != null) {
                return String(item);
            }
            return null;
        })
            .filter((text) => text !== null && text !== '' && text !== '-');
        return textValues.length > 0 ? textValues.join(delimiter) : '';
    },
});
//# sourceMappingURL=join-list-as-text.js.map